import Logo from "../../../assets/images/Logo-echoed.svg";

export const ChoosePlan = ({ setStep }) => (
  <>
    <img src={Logo} alt="logo" width={120} className="pointer p-b-20" />
    <div className="auth-form choose-plan">
      <div className="auth-items">
        <div className="w-30p">
          <div className="space-between">
            <span className="bold font-16"> Small Teams </span>
            <span className="bold font-16">
              $999<span className="normal">/mo</span>
            </span>
          </div>
          <div className="p-tb-20 font-12">Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni, eligendi.</div>
          <div className="btn-full" onClick={() => setStep("payment")}>
            Subscribe
          </div>
          <div className="plan-features">
            <ul>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
            </ul>
          </div>
        </div>
        <div className="w-30p">
          <div>
            <span className="bold font-16"> Educational Instituion </span>
          </div>
          <div className="p-tb-20 font-12">Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni, eligendi.</div>
          <div className="btn-full" onClick={() => setStep("payment")}>
            Request Trial
          </div>
          <div className="plan-features">
            <ul>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
            </ul>
          </div>
        </div>
        <div className="w-30p">
          <div>
            <span className="bold font-16"> Enterprise </span>
          </div>
          <div className="p-tb-20 font-12">Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni, eligendi.</div>
          <div className="btn-full" onClick={() => setStep("payment")}>
            Request Trial
          </div>
          <div className="plan-features">
            <ul>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
              <li> Need help</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </>
);
